const MIDDLE_DOT = "\u00B7";

export const SUBSCRIPTION_BAR_STATE = {
  LAPSED: "lapsed",
  CURRENT: "current",
  FUTURE: "future",
};

const VALID_STATES = new Set(Object.values(SUBSCRIPTION_BAR_STATE));

export function normalizeSubscriptionBarState(raw) {
  const key = String(raw || "")
    .toLowerCase()
    .trim();
  if (key.startsWith("current")) return SUBSCRIPTION_BAR_STATE.CURRENT;
  if (key.startsWith("future")) return SUBSCRIPTION_BAR_STATE.FUTURE;
  return VALID_STATES.has(key) ? key : SUBSCRIPTION_BAR_STATE.LAPSED;
}

export function formatSubscriptionBarLabel(subscriptionCode, title) {
  const code = String(subscriptionCode || "").trim();
  const name = String(title || "").trim();
  if (code && name) return `${code} ${MIDDLE_DOT} ${name}`;
  return code || name;
}

export function formatSubscriptionBarAriaLabel(state, subscriptionCode, title) {
  const stateLabel = normalizeSubscriptionBarState(state);
  const label = formatSubscriptionBarLabel(subscriptionCode, title);
  return label ? `${stateLabel} subscription ${label}` : `${stateLabel} subscription`;
}
